import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export const orderStatusStyles = (color?: string, backgroundColor?: string) => {
    return css`
        display: inline-block;
        padding: 0.3em 1em;
        border: 0.0625rem solid ${getColor(color)};
        background-color: ${getColor(backgroundColor)};
        color: ${getColor(color)};
    `;
};
